import React from 'react';
import { useAppSelector } from '../../../../../shared/hooks';
import { redirectToLogin } from '../../../../../shared/utils';

export function Logout() {
  const loginURL = useAppSelector((x) => x.app.associatedInstance?.settings?.loginUrl);
  redirectToLogin({ authError: false }, false, loginURL);
  return <p>Redirecting to login page...</p>;
}
